import { transcode } from "buffer";
import { transitions } from "polished";
import React, { useEffect, useState } from "react";


export default function TopProgressBar() {

    const [scrolled, setScrolled] = useState('0');
    let initPosition = 50;

    const scrollProgress = () => {
        const scrollPx = document.documentElement.scrollTop;
        const winHeightPx =
            document.documentElement.scrollHeight -
            document.documentElement.clientHeight;
        const scrolled_ = `${scrollPx / winHeightPx * 50}%`;
        console.log(scrolled_);
        setScrolled(scrolled_)
    };

    useEffect(() => {
        window.addEventListener("scroll", scrollProgress);
    }, [])
    const progressContainerStyle = {
        background: "#f8bbd00",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
        height: "4px",
        transition: "null 0.2s ease-out 0s",
        top: 0,
        left: `${initPosition - Number(scrolled.replaceAll('%', ''))}%`,
        right: `${initPosition - Number(scrolled.replaceAll('%', ''))}%`,
        zIndex: 99
    };

    const progressBarStyle = {
        height: "4px",
        transition:"null 0.2s ease-out 0s",
        background: "#0345ca",
        width: `${Number(scrolled.replaceAll('%', '')) + Number(scrolled.replaceAll('%', ''))} %`
    };

    return (
        <div className="progress-container" style={progressContainerStyle}>
            <div className="progress-bar" style={progressBarStyle} />
        </div>
    )
}